import React from "react";
import { useTranslation } from "react-i18next";
import { UPREALITY_LINKEDIN_COMPANY_URL } from "../constants/brand";
import styles from "./HpFooter.module.css";

function FooterWaves() {
  return (
    <svg
      className={styles.waves}
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path d="M0 80c192-68 358-43 529 29 201 84 355 65 527-21C1194 19 1322 23 1440 76v244H0Z" fill="#32b9b5" />
      <path d="M0 132c190-59 355-37 532 29 194 73 353 45 526-28 143-60 263-46 382 3v184H0Z" fill="#83d6cc" />
      <path d="M0 187c181-50 347-34 530 19 197 57 362 22 533-37 141-49 259-27 377 16v135H0Z" fill="#bfeadc" />
      <path d="M0 245c188-37 357-22 540 14 193 38 358-1 527-39 137-31 255-7 373 26v74H0Z" fill="#dff4ed" />
    </svg>
  );
}

/**
 * Footer HP style zip Revamping UI (fond #123235 + vagues).
 * @param {{ analyticsManager?: object, analyticsOrigin?: string, compact?: boolean }} props
 */
export default function HpFooter({
  analyticsManager,
  analyticsOrigin = "home_page_ad",
  compact = false,
}) {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={`${styles.footer}${compact ? ` ${styles.footerCompact}` : ""}`}>
      <FooterWaves />
      <div className={styles.content}>
        <div className={styles.top}>
          <a
            className={styles.logo}
            href="#top"
            aria-label="UpReality"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img src="/images/app_icon.png" alt="" />
            <span className={styles.logoWordmark}>UpReality</span>
          </a>
          <p className={styles.tagline}>
            <span className={styles.taglineLead}>
              {t("InstantAdHero1")}{" "}
              <span className={styles.taglineAccent}>{t("InstantAdHero2")}</span>{" "}
              {t("InstantAdHero3")}
            </span>
            <span className={styles.taglineSub}>
              {t("InstantAdHero41")}{t("InstantAdHero42")}
            </span>
          </p>
          <a className={styles.email} href="mailto:contact@upreality.store">
            contact@upreality.store
          </a>
        </div>
        <div className={styles.bottom}>
          <span className={styles.copyright}>
            {t("FooterCopyright", { year })}
          </span>
          <div className={styles.links}>
            <a
              href="/terms/cgu.pdf"
              target="_blank"
              rel="noreferrer"
              onClick={() => analyticsManager?.logReadCGUTag?.(analyticsOrigin)}
            >
              {t("Terms")}
            </a>
            <a
              href="/terms/charte_confidentialite.pdf"
              target="_blank"
              rel="noreferrer"
              onClick={() => analyticsManager?.logReadPrivacyTag?.(analyticsOrigin)}
            >
              {t("Privacy")}
            </a>
            <a
              href="/terms/cgv.pdf"
              target="_blank"
              rel="noreferrer"
              onClick={() => analyticsManager?.logReadCGVTag?.(analyticsOrigin)}
            >
              {t("CGV")}
            </a>
            <a
              href={UPREALITY_LINKEDIN_COMPANY_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("FooterFollowUsLinkedInAria")}
            >
              {t("FooterLinkedInShort")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
